import { AxiosError } from 'axios';
import toastify from '../lib/toastify';
import { LISTING_QUERY } from '../queries';
import { getListing } from '../services/Listings.service';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { scrollWindowTo } from '../utils/scroll';
import { useQuery } from '@tanstack/react-query';
import { ListingContextReturn } from '../store/contexts/types/listing';
import { getListingWithStatus } from '../utils/get-listing-with-status';

export function useListing(): ListingContextReturn {
  const history = useHistory();

  const { data, isError, isLoading, error, isInitialLoading, isRefetching } = useQuery({
    queryKey: [LISTING_QUERY],
    queryFn: getListing,
    refetchOnWindowFocus: 'always',
    refetchOnMount: 'always'
  });

  useEffect(() => {
    if (isError) {
      const axiosError = error as AxiosError;
      if (axiosError?.response?.status === 404) {
        return;
      }
      toastify.error('falha na requisição', 'não foi possível buscar seus anúncios neste momento');
      return history.push('/404');
    }
  }, [isError, error, history]);

  useEffect(() => {
    scrollWindowTo(0);
  }, [isInitialLoading]);

  return {
    listing: data?.content ? getListingWithStatus(data?.content) : undefined,
    loading: isLoading,
    error: isError,
    isRefetching
  };
}
